import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarShipment(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="Shipment"?"":"Shipment")} title="Shipment" className={props.activeMenu == "Shipment" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("shipment:shipment:view")?false:true}>
                <i className="fa fa-database sidenavbar-icon px-3"></i>
                <span className="mx-3 sidenavbar-text">Shipments
                    <i className={showMenu=="Shipment"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "Shipment" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => setShowSubMenu(showSubMenu=="Exports"?"":"Exports")} title="Exports" 
                    className={
                        props.activeSubMenu == "Exports" && showSubMenu != "Exports" ? "sidenav-expanded-active pointer px-0" 
                        : 
                        props.activeSubMenu == "Exports" && showSubMenu=="Exports"?"submenu-open pointer px-0"
                        :
                        props.activeSubMenu != "Exports" && showSubMenu=="Exports"?"submenu-open pointer px-0"
                        :
                        "pointer px-0"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:export:view")?false:true}>
                    <span className="mx-3 sidenavbar-text">Exports 
                        <i className={showMenu=="Shipment" && showSubMenu=="Exports"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                    </span>
                </a>

                <ul id="custom-multilevel-submenu" className={showMenu=="Shipment" && showSubMenu=="Exports"? "multilevel-sidenav-submenu bg-theme-light-green": "display-none"}>
                    <a onClick={() => navigate("/shipment/plannedexports")} title="Planned Exports" 
                    className={props.activeSubMenuLevel1 == "PlannedExports" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:plannedexport:view")?false:true}>
                        Export Bookings
                    </a>

                    {/* <a onClick={() => navigate("/shipment/sobbooking")} title="SOB Bookings" 
                    className={props.activeSubMenuLevel1 == "SobBookings" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:sobbooking:view")?false:true}>
                        SOB Bookings
                    </a>

                    <a onClick={() => navigate("/shipment/closedbooking")} title="Closed Bookings" 
                    className={props.activeSubMenuLevel1 == "ClosedBookings" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:closedbooking:view")?false:true}>
                        Closed Bookings
                    </a>

                    <a onClick={() => navigate("/shipment/cancelledbooking")} title="Cancelled Bookings" 
                    className={props.activeSubMenuLevel1 == "CancelledBookings" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:cancelledbooking:view")?false:true}>
                        Cancelled Bookings
                    </a> */}

                    <a onClick={() => navigate("/shipment/exportreport")} title="Export Report" 
                    className={props.activeSubMenuLevel1 == "ExportReport" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:exportreport:view")?false:true}>
                        Export Report
                    </a>

                    <a onClick={() => navigate("/shipment/loadlist")} title="Load List" 
                    className={props.activeSubMenuLevel1 == "LoadList" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:loadlist:view")?false:true}>
                        Load List
                    </a>
                </ul>
            </ul>

            <ul className={showMenu == "Shipment" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => setShowSubMenu(showSubMenu=="Imports"?"":"Imports")} title="Imports" 
                    className={
                        props.activeSubMenu == "Imports" && showSubMenu != "Imports" ? "sidenav-expanded-active pointer px-0" 
                        : 
                        props.activeSubMenu == "Imports" && showSubMenu=="Imports"?"submenu-open pointer px-0"
                        :
                        props.activeSubMenu != "Imports" && showSubMenu=="Imports"?"submenu-open pointer px-0"
                        :
                        "pointer px-0"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:import:view")?false:true}>
                    <span className="mx-3 sidenavbar-text">Imports 
                        <i className={showMenu=="Shipment" && showSubMenu=="Imports"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                    </span>
                </a>

                <ul id="custom-multilevel-submenu" className={showMenu=="Shipment" && showSubMenu=="Imports"? "multilevel-sidenav-submenu bg-theme-light-green": "display-none"}>
                    <a onClick={() => navigate("/shipment/plannedimports")} title="Planned Imports" 
                    className={props.activeSubMenuLevel1 == "PlannedImports" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:plannedimport:view")?false:true}>
                        Planned Imports
                    </a>

                    <a onClick={() => navigate("/shipment/arrivedimports")} title="Arrived Imports" 
                    className={props.activeSubMenuLevel1 == "ArrivedImports" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:arrivedimport:view")?false:true}>
                        Arrived Imports
                    </a>

                    <a onClick={() => navigate("/shipment/importreport")} title="Import Report" 
                    className={props.activeSubMenuLevel1 == "ImportReport" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:importreport:view")?false:true}>
                        Import Report
                    </a>
                </ul>
            </ul>

            <ul className={showMenu == "Shipment" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => setShowSubMenu(showSubMenu=="Transhipments"?"":"Transhipments")} title="Transhipments" 
                    className={
                        props.activeSubMenu == "Transhipments" && showSubMenu != "Transhipments" ? "sidenav-expanded-active pointer px-0" 
                        : 
                        props.activeSubMenu == "Transhipments" && showSubMenu=="Transhipments"?"submenu-open pointer px-0"
                        :
                        props.activeSubMenu != "Transhipments" && showSubMenu=="Transhipments"?"submenu-open pointer px-0"
                        :
                        "pointer px-0"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:transhipment:view")?false:true}>
                    <span className="mx-3 sidenavbar-text">Transhipments 
                        <i className={showMenu=="Shipment" && showSubMenu=="Transhipments"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                    </span>
                </a>

                <ul id="custom-multilevel-submenu" className={showMenu=="Shipment" && showSubMenu=="Transhipments"? "multilevel-sidenav-submenu bg-theme-light-green": "display-none"}>
                    <a onClick={() => navigate("/shipment/plannedtranshipment")} title="Planned Transhipments" 
                    className={props.activeSubMenuLevel1 == "PlannedTranshipments" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:plannedtranshipment:view")?false:true}>
                        Planned Transhipments
                    </a>

                    <a onClick={() => navigate("/shipment/arrivedtranshipment")} title="Arrived Transhipments" 
                    className={props.activeSubMenuLevel1 == "ArrivedTranshipments" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:arrivedtranshipment:view")?false:true}>
                        Arrived Transhipments
                    </a>

                    <a onClick={() => navigate("/shipment/departedtranshipment")} title="Departed Transhipments" 
                    className={props.activeSubMenuLevel1 == "DepartedTranshipments" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:departedtranshipment:view")?false:true}>
                        Departed Transhipments
                    </a>

                    <a onClick={() => navigate("/shipment/transhipmentreport")} title="Transhipment Report" 
                    className={props.activeSubMenuLevel1 == "TranshipmentReport" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("shipment:transhipmentreport:view")?false:true}>
                        Transhipment Report
                    </a>
                </ul>
            </ul>
        </>
    );
}

export default SideNavBarShipment;
